export const CORE_API = {
  USER_LOGI_IN: "v1/Auth/Login",
  USER_FORGOT_PASSWORD: "v1/Auth/ForgotPassword",
  USER_RESET_PASSWORD: "v1/Auth/UpdatePassword",
  GET_DIRECTORY_META_DATA_LIST: "v1/Directory/GetDirectoryMetaDataList",
  GET_ALL_PRODUCT_INVENTORY: 'v1/ProductDetails/GetSNMCCAndNonSNMCCProductHeaders',
  GLOBAL_SEARCH: 'v1/ProductDetails/GlobalHeaderSearch',
  GET_STORE_USER_DETAILS_BY_TOKEN: 'v1/Store/GetUserDetailByTocken',
  INSERT_USER: 'v1/user/InsertDefaultUser',
  GET_INWARD_COUNT: 'v1/productdetails/GetProductCount',
  GET_NOTIFICATIONS_LIST: 'v1/Notification/GetNotificationsList',
  NOTIFICATION_MARK_AS_READ: 'v1/Notification/NotificationMarkAsRead',
  GET_STORE_LIST: 'v1/Store/GetStoresSelectList',
  GET_INVOICE_LIST: 'v1/ProductDetails/GetInvoiceNumbersDropdown',
  GET_NOTIFICATIONS_UNREAD_COUNT: 'v1/Notification/GetNotificationsUnreadCount',
  SEND_OTP: 'v1/OTP/SendOtp',
  VERIFY_OTP: 'v1/OTP/VerifyAdvancePaymentOtp',
  LOGOUT_USER: 'v1/Auth/Logout',
  GET_CURRENT_APP_VERSION: 'v1/Dashboard/GetCurrentAppVersion',
  GET_CURRENT_APP_VERSION_FEATURE_BY_ID: 'v1/Dashboard/GetAppVersionFeatureById',
  GET_ALL_APP_VERSIONS: 'v1/Dashboard/GetAllAppVersions',
  GET_ALL_APP_VERSION_FEATURES: 'v1/Dashboard/GetAllAppVersionFeatures',
  GET_SUPPORT_USER_INFO: 'v1/Customer/GetActiveSupportNumbers',

}
